import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage'; // Import Firebase Storage'
import 'firebase/compat/database';

const firebaseConfig = {
  apiKey: "AIzaSyCFYqlJkBsgtSPHNg6KzbfI_3TBcLoRxoY",
  authDomain: "enbybase.firebaseapp.com",
  projectId: "enbybase",
  storageBucket: "enbybase.appspot.com",
  messagingSenderId: "538194279584",
  appId: "1:538194279584:web:6ddd49a76b212bd72a5dc5",
  measurementId: "G-QVTVFBYSSK"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

// Export Firebase services
export const auth = firebaseApp.auth();
export const storage = firebaseApp.storage(); // Export Firebase Storage
export const firestore = firebaseApp.firestore(); // Export Firestore if needed
export const database = firebaseApp.database();

const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

export const signInWithGoogle = () => auth.signInWithPopup(provider);
export const signInWithEmail = (email, password) => {
  return auth.signInWithEmailAndPassword(email, password);
};
// Export signOut function
export const signOut = () => auth.signOut();
export default firebaseApp;
